import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getLocaleStringForSupportLink } from 'libs/common';
import './Footer.scss';

function Footer(props) {
  const { i18n: { info: { locale } } } = props;
  return (
    <div className="SubscriptionActivate__Footer">
      <div className="SubscriptionActivate__Footer__Content__Divider" />
      <div className="SubscriptionActivate__Footer__Content__Links">
        <a href={`http://www.choosemuse.com/${getLocaleStringForSupportLink(locale)}`} className="SubscriptionActivate__Footer__Content__Links__Text" rel="noopener noreferrer" target="_blank">
          <FormattedMessage id="views.subscriptionActivate.footer.termsOfService" />
        </a>
        <span className="SubscriptionActivate__Footer__Content__Links__Divider">|</span>
        <a href={`http://www.choosemuse.com/${getLocaleStringForSupportLink(locale)}legal/#privacy`} rel="noopener noreferrer" target="_blank" className="SubscriptionActivate__Footer__Content__Links__Text">
          <FormattedMessage id="views.subscriptionActivate.footer.privacy" />
        </a>
        <span className="SubscriptionActivate__Footer__Content__Links__Divider">|</span>
        <a href="https://choosemuse.com/contactsupport" className="SubscriptionActivate__Footer__Content__Links__Text">
          <FormattedMessage id="views.subscriptionActivate.footer.contactUs" />
        </a>
      </div>
    </div>
  );
}

Footer.propTypes = {
  i18n: PropTypes.object.isRequired
};

export default connect(
  ({
    i18n
  }) => ({
    i18n
  })
)(Footer);



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/Footer/Footer.jsx